import { writable } from 'svelte/store'

export let screenStore = writable([]);
